import { render, staticRenderFns } from "./ProjectCarousel.vue?vue&type=template&id=77b03807&scoped=true&"
import script from "./ProjectCarousel.vue?vue&type=script&lang=js&"
export * from "./ProjectCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCarousel.vue?vue&type=style&index=0&id=77b03807&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b03807",
  null
  
)

export default component.exports